import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

interface AttendanceStatus {
    attendanceStatus: boolean;
    mFineFGPC: boolean;
    mFineFreeSpecialist: boolean;
    isCorporateHealthCheckupRestricted: boolean;
    isPsychiatristTab: boolean;
}

@Injectable()
export class SharingDataService {


    public returnUrl = new BehaviorSubject('/home');
    returnUrl$ = this.returnUrl.asObservable();

    public familyHealthData = new BehaviorSubject('');
    familyHealthData$ = this.familyHealthData.asObservable();
    public teamdata=new BehaviorSubject<any>(null);
    
    constructor() { }

    getReturnUrl(url) {
        this.returnUrl.next(url);
    }

    familyHealthDetails(porposalFromDetails) {
        this.familyHealthData.next(porposalFromDetails)
    }
    
    emit<T>(data:T){
     this.teamdata.next(data);
     }

     on<T>():Observable<T>{
         return this.teamdata.asObservable();
     }

     attendanceSubject = new BehaviorSubject<AttendanceStatus>({
        attendanceStatus: false,
        mFineFGPC: false,
        mFineFreeSpecialist: false,
        isCorporateHealthCheckupRestricted: false,
        isPsychiatristTab: false
    });
}